"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForwardMessageContext = void 0;
const react_1 = require("react");
exports.ForwardMessageContext = (0, react_1.createContext)({});
